import axios from 'axios';
import { loadConfig } from './config';

let apiInstance = null;

export const initializeApi = async () => {
    if (!apiInstance) {
        const config = await loadConfig();
        apiInstance = axios.create({
            baseURL: config.REACT_APP_API_URL,
            withCredentials: true
        });

        apiInstance.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('token');
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );
    }
    return apiInstance;
};

export const getApiInstance = () => {
    if (!apiInstance) {
        throw new Error('API not initialized. Call initializeApi first.');
    }
    return apiInstance;
};